// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3ULol","validationTips":"StatementDescriptor_validationTips__2-lKE"};